import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Resource_AppointmentMsg, Resource_AppointmentStatus } from '../../src/generated/graphql';
import styles from './appointment-details.module.scss';

interface AppointmentCancellationProps {
  appointment: Maybe<Resource_AppointmentMsg> | undefined;
}

export const AppointmentCancellation: FC<AppointmentCancellationProps> = ({ appointment }) => {
  const { formatMessage } = useIntl();
  const cancelled =
    appointment?.appointmentStatus === Resource_AppointmentStatus.AppointmentStatusCancelled;
  const reasonsForCancellationExternal = appointment?.eventHistory?.find(
    (event) =>
      event?.appointmentStatus === Resource_AppointmentStatus.AppointmentStatusCancelled &&
      event?.reasonsForCancellationExternal &&
      event?.reasonsForCancellationExternal?.length > 0,
  )?.reasonsForCancellationExternal;

  return cancelled ? (
    <Card className={styles.cancellation}>
      <Title level={3} style={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'appointment.cancellation' })}
      </Title>
      <p>{formatMessage({ id: 'appointment.cancellation.description' })}</p>

      {reasonsForCancellationExternal && reasonsForCancellationExternal?.length > 0 && (
        <>
          {formatMessage(
            { id: 'appointment.cancellation.reasons' },
            {
              reason: reasonsForCancellationExternal?.map((reason) => reason?.text)?.join(', '),
            },
          )}
        </>
      )}
    </Card>
  ) : null;
};
